// Questions for lawyers: appearances where the billing note asks something (it contains a
// "?") or the row is set to Query, grouped by the lawyer with carriage, so each lawyer can
// be sent their own list.

export function isQuestion(note = "", action = "") {
  return action === "Query" || String(note).includes("?");
}

export function buildLawyerQuestions(entries = [], actions = {}, notes = {}) {
  const groups = new Map();
  for (const entry of entries) {
    const note = String(notes[entry.id] || "").trim();
    const action = actions[entry.id] || "";
    if (!isQuestion(note, action)) continue;
    const lawyer = String(entry.lawyer_initials || "").trim().toUpperCase() || "No lawyer recorded";
    if (!groups.has(lawyer)) groups.set(lawyer, []);
    groups.get(lawyer).push({ entry, note, action });
  }
  return [...groups.entries()]
    .map(([lawyer, items]) => ({ lawyer, items }))
    .sort((a, b) => (a.lawyer === "No lawyer recorded") - (b.lawyer === "No lawyer recorded") || a.lawyer.localeCompare(b.lawyer));
}

// Plain text for pasting into an email to the lawyer.
export function lawyerQuestionsText({ lawyer, items }, weekLabel = "") {
  const lines = [
    `Billing questions${weekLabel ? ` - week ${weekLabel}` : ""} (${lawyer})`,
    "",
  ];
  items.forEach(({ entry, note, action }, index) => {
    lines.push(`${index + 1}. ${entry.date || "Date not recorded"} - ${entry.client_name || "Client not named"}`);
    const where = [entry.court, entry.appearance_type].filter(Boolean).join(" - ");
    if (where) lines.push(`   ${where}`);
    if (entry.outcome) lines.push(`   Outcome: ${entry.outcome}`);
    lines.push(`   Question: ${note || (action === "Query" ? "Please see query on this appearance." : "")}`);
    lines.push("");
  });
  return lines.join("\n").trimEnd();
}
